import { gql } from '@/utilities/gql';
import type { ResultOf } from '@/utilities/gql';

export const NOTE_FRAGMENT = gql(`
  fragment NoteFields on Note @_unmask {
    id
    userId
    content
    contentPreview
    createdAt
    updatedAt
    noteType {
      name
    }
    noteVisibility {
      name
    }
    reminders {
      id
      status
      type
      customMessage
      deliveryDateUtc
      userTimezone
      reminderTarget {
        targetValue
        targetMetadata
      }
    }
    company {
      id
      canonicalURL
      uniqueSymbol
      listingCurrencyISO
      analysisValue {
        lastSharePrice
      }
    }
  }
`);

export type NoteFragmentType = ResultOf<typeof NOTE_FRAGMENT>;
